export const userHasRole = (userRoles, requiredRoles) => userRoles.some((r) => requiredRoles.includes(r));
